<template>
  <div>
    <nav class="row">
      <div
        class="col-4 px-3 border-right border-light"
        style="background: #fff !important"
      >
        <div class="row justify-content-between profile h-100">
          <VueCustomTooltip
            :label="user.nameUser"
            position="is-right"
            class="col-16 align-self-center z-up d-none d-md-flex"
          >
            <h3
              class="col-24 mr-2 align-self-center z-up text-truncate2"
              v-text="user.nameUser"
            ></h3>
          </VueCustomTooltip>

          <div
            class="col-auto align-self-center d-flex align-items-center"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <object
              class="rounded-circle"
              width="28"
              height="28"
              :data="user.link"
              type="image/png"
            >
              <img
                width="28"
                height="28"
                src="../../assets/images/default.png"
                alt="Avatar"
              />
            </object>
            <i @click="$refs.dropdown.show()" class="ml-2">
              <img
                src="../../../src/assets/icons/plus-circle.png"
                class="align-self-center pointer d-none d-md-flex ico-16"
                width="16"
                height="16"
              />
            </i>
          </div>
        </div>
      </div>

      <b-dropdown ref="dropdown" split class="dropdown-links drop-menu-nav">
        <div v-if="user.typeUser == 'company'">
          <p class="dropdown-item h-options d-flex pl-3 pr-3 pt-2 pb-2 m-0">
            <span v-text="$ml.get('programs')">Programas</span>
          </p>
          <router-link
            to="/program/create?public"
            class="dropdown-item h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
          >
            <font v-text="$ml.get('createA')">Criar um</font
            ><strong class="ml-1" v-text="$ml.get('publicProgram')"
              >programa público</strong
            >
          </router-link>
          <router-link
            to="/program/create?private"
            class="dropdown-item h-options d-flex pl-3 pr-5 pt-1 pb-2 m-0 link-block"
          >
            <font v-text="$ml.get('createA')">Criar um</font
            ><strong class="ml-1" v-text="$ml.get('privateProgram')"
              >programa privado</strong
            >
          </router-link>
          <div class="dropdown-divider"></div>

        <p class="dropdown-item h-options d-flex pl-3 pr-3 pt-2 pb-2 m-0">
          <span>Pentests</span>
        </p>
          <router-link
            @click="saveToLocalStorageAndNavigate('whitebox')"
            to="/create/pentest?target"
            class="dropdown-item h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
          >
            <font v-text="$ml.get('createA')">Criar um</font
            ><strong class="ml-1" 
              >pentest {{ $ml.get('whitebox').toLowerCase() }}</strong
            >
          </router-link>
           <p  @click="saveToLocalStorageAndNavigate('blackbox')">
             <router-link             
              to="/create/pentest?target"
              class="dropdown-item h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
              >
              <font v-text="$ml.get('createA')">Criar um</font
              ><strong class="ml-1"
                >pentest {{ $ml.get('blackbox').toLowerCase() }}</strong
              >
                       </router-link>
           </p>
          <div class="dropdown-divider"></div>

        </div>
        <p class="dropdown-item h-options d-flex pl-3 pr-3 pt-2 pb-2 m-0">
          <span v-text="$ml.get('menuAccount')">Minha Conta</span>
        </p>
        <router-link
          to="/account"
          class="dropdown-item h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
          v-text="$ml.get('profileInformation')"
        >
        </router-link>
        <router-link
          :to="
            '/account?' + (user.typeUser == 'company' ? 'invoices' : 'revenues')
          "
          class="dropdown-item h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
          v-text="$ml.get('billingInformation')"
        >
        </router-link>
        <router-link
          to="/account?access"
          class="dropdown-item h-options d-flex pl-3 pr-5 pt-2 pb-1 m-0 link-block"
          v-text="$ml.get('access')"
        >
        </router-link>
      </b-dropdown>

      <div class="col-16 row justify-content-between py-1 px-3">
        <!-- Itens subMenu Dashboard -->
        <ul
          v-if="currentRouteName == 'dashboard'"
          class="none-p-m d-flex align-items-center"
        >
          <li>
            <router-link
              to="/dashboard"
              :class="currentRoutePath == '/dashboard' ? 'active' : ''"
            >
              Home
            </router-link>
          </li>
          <li v-if="user.typeUser === 'company' && (user.userRole === 'owner' || user.userRole === 'admin')">
            <router-link
              to="/overview"
              :class="currentRoutePath == '/overview' ? 'active' : ''"
            >
              Overview
            </router-link>
          </li>
          <li class="notify d-flex" style="gap:2px">
            <router-link
              v-text="$ml.get('navInvitations')"
              to="/dashboard/invitations"
              :class="
                currentRoutePath == '/dashboard/invitations' ? 'active' : ''
              "
            >
            </router-link>
            <div v-if="user.typeUser === 'hacker' && pendingInvitations" class="notify-invitations"></div>
          </li>
          <li class="notify">
            <router-link
              v-text="
                $ml.get(user.typeUser == 'company' ? 'invoices' : 'navPayments')
              "
              :to="
                '/dashboard/' +
                (user.typeUser == 'company' ? 'invoice' : 'payment')
              "
              :class="
                ['/dashboard/payment', '/dashboard/invoice'].includes(
                  currentRoutePath,
                )
                  ? 'active'
                  : ''
              "
            >
            </router-link>
          </li>
          <li v-if="user.typeUser === 'company' && (user.userRole === 'owner' || user.userRole === 'admin') && canSendCustomEmail">
            <router-link
              to="/email"
              :class="currentRoutePath == '/email' ? 'active' : ''"
            >
              {{$ml.get('navCustomEmail')}}
            </router-link>
          </li>
        </ul>

        <!-- Itens subMenu Wiki -->
        <ul
          v-if="currentRouteName == 'wiki'"
          class="none-p-m d-flex align-items-center"
        >
          <li>
            <router-link
              to="/wiki"
              :class="currentRoutePath == '/wiki' ? 'active' : ''"
            >
              Wiki
            </router-link>
          </li>
          <li class="notify">
            <router-link
              to="/wiki/suport"
              :class="currentRoutePath == '/wiki/suport' ? 'active' : ''"
              v-text="$ml.get('support')"
            >
            </router-link>
          </li>
        </ul>

        <!-- Itens subMenu Program -->
        <ul
          v-if="currentRouteName == 'program'"
          class="none-p-m d-flex align-items-center"
        >
          <li>
            <router-link
              v-text="$ml.get('navPrograms')"
              to="/program"
              :class="currentRoutePath == '/program' ? 'active' : ''"
            >
            </router-link>
          </li>

          <li class="notify">
            <router-link
              v-text="$ml.get('navInvitations')"
              to="/program/invitations"
              :class="
                currentRoutePath == '/program/invitations' ? 'active' : ''
              "
            >
            </router-link>
            <!-- <span>&nbsp;|&nbsp;</span><span class='notify-number'>2</span> -->
          </li>

          <li v-if="user.typeUser == 'company'">
            <router-link
              v-text="$ml.get('navPublished')"
              to="/program/published"
              :class="currentRoutePath == '/program/published' ? 'active' : ''"
            >
            </router-link>
            <!-- <span>&nbsp;|&nbsp;</span><span class='notify-number'>2</span> -->
          </li>
          <li v-if="user.typeUser == 'company'">
            <router-link
              v-text="$ml.get('navClosed')"
              to="/program/inactive"
              :class="currentRoutePath == '/program/inactive' ? 'active' : ''"
            >
            </router-link>
            <!-- <span>&nbsp;|&nbsp;</span><span class='notify-number'>1</span> -->
          </li>
          <li class="notify">
            <router-link
              v-text="$ml.get('navNda')"
              to="/program/nda"
              :class="currentRoutePath == '/program/nda' ? 'active' : ''"
            >
            </router-link>
            <!-- <span>&nbsp;|&nbsp;</span><span class='notify-number'>1</span> -->
          </li>

          <li class="notify" v-if="user.typeUser == 'company'">
            <router-link
              to="/program/vpn"
              :class="currentRoutePath == '/program/vpn' ? 'active' : ''"
            >
              VPNs
            </router-link>
          </li>
          <li class="notify" v-if="user.typeUser == 'company'">
            <router-link
              v-text="$ml.get('progCampTitle')"
              to="/program/campaign"
              :class="currentRoutePath == '/program/campaign' ? 'active' : ''"
            >
            </router-link>
          </li>
        </ul>

        <!-- Itens subMenu Ranking-->
        <ul
          v-if="currentRouteName == 'ranking'"
          class="none-p-m d-flex align-items-center"
        >
          <li>
            <router-link
              v-text="$ml.get('generalRanking')"
              to="/ranking"
              :class="currentRoutePath == '/ranking' ? 'active' : ''"
            >
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('monthlyRanking')"
              to="/rankingMonthly"
              :class="currentRoutePath == '/rankingMonthly' ? 'active' : ''"
            >
            </router-link>
          </li>
          <li v-if="!(user.typeUser == 'company')">
            <router-link
              v-text="'Timeline'"
              to="/ranking/timeline"
              :class="currentRoutePath == '/ranking/timeline' ? 'active' : ''"
            >
            </router-link>
          </li>
        </ul>

        <!-- Itens subMenu Report-->
        <ul
          v-if="currentRouteName == 'report'"
          class="none-p-m d-flex align-items-center"
        >
          <li>
            <router-link
              v-text="$ml.get('navAll')"
              to="/report"
              :class="currentRoutePath == '/report' ? 'active' : ''"
            >
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('navPending')"
              to="/report/pending"
              :class="currentRoutePath == '/report/pending' ? 'active' : ''"
            >
            </router-link>
            <!-- <span>&nbsp;|&nbsp;</span><span class='notify-number'>2</span> -->
          </li>
          <li>
            <router-link
              v-text="$ml.get('navRetest')"
              to="/report/retest"
              :class="currentRoutePath == '/report/retest' ? 'active' : ''"
            >
            </router-link>
          </li>
          <li>
            <router-link
              v-text="$ml.get('triaged')"
              to="/report/triaged"
              :class="currentRoutePath == '/report/triaged' ? 'active' : ''"
            >
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
import store from "@/state/store";

export default {
  components: {},
  data() {
    return {
      user: {
        nameUser: "",
        link: "",
        typeUser: "",
        userRole: "",
        // pending_invitations:0,

        canSendCustomEmail: false,
      },
    };
  },
  methods:{
  saveToLocalStorageAndNavigate(type) {
      localStorage.setItem("type_pentest", type);
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.meta.name;
    },
    pendingInvitations(){
      return this.$store.getters['getUser'].pending_invitations > 0 ? true : false;
    },
    currentRoutePath() {
      return this.$route.path;
    },
  },
  mounted() {
    this.canSendCustomEmail = this.$store.getters['getUser']?.plan?.can_send_custom_email
    this.user.link =
      store.getters["getUserType"] == "company"
        ? store.getters["getUser"].company_avatar
        : store.getters["getUser"].account_avatar;
    this.user.typeUser = store.getters["getUserType"];
    this.user.nameUser =
      this.user.typeUser == "company"
        ? store.getters["getUser"].companyName
        : store.getters["getUser"].name;

    this.user.userRole = store.getters['getUserRole'];
  },

};
</script>
<style lang="scss">
.text-truncate2 {
  overflow: hidden !important;
  display: inline-block !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.dropdown-links {
  button {
    width: 1px;
    height: 1px;
    opacity: 0;
    padding: 0 !important;
  }
}
.drop-menu-nav {
  top: -15px;
  left: -15px;
}
.notify-invitations{
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #06d6a0;
}
.dropdown-menu{
  z-index:10000;
}
</style>
